import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _UBLInvoice } from '../../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectSupplierPaymentTypeConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_UBLInvoice)
    const [id, setID] = useState(idSelector ?? "");

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e) => {
        if (e === "") {
            setID("");
            onChange(null)
        } else {
            setID(e);
            onChange(parseInt(e))
        }
    };

    const getLista = () => {
        instance.getSupplierPaymentTypeConstants(null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => {
            setLista([]);
        });
    };


    return (
        <>
            <label>{label ?? "Tipos de Labor"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}